import axios from "axios";
import AxiosAPI from "./AxiosAPI";

export const loginUser = async (data) => {
  const response = await AxiosAPI.post("/user/signin", data);
  return response.data;
};

export const saveLoginRecord = async (data) => {
  const response = await axios.post(`https://posibleapi-uat-789032243296.asia-south1.run.app/v1/user/loginrecord`, data);
  return response.data;
};
// export const saveLoginRecord = async (data) => {
//   const response = await axios.post(`http://localhost:4000/v1/v1/user/loginrecord`, data);
//   return response.data;
// };


